import React from "react";
import { Layout } from "./Pages/Layout";
import { Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";

function App() {
  return (
    <>
      <Toaster />
      <Routes>
        <Route path="*" element={<Layout />} />
      </Routes>
    </>
  );
}

export default App;
